import { DocumentNode, gql } from "@apollo/client";
import { baseCategoryDescriptionTaxonomy } from "./base";

const WATER_PROVIDER_KPI_DESCRIPTION_QUERY = `
    kpiDescription {
        ${baseCategoryDescriptionTaxonomy}
    }
`;

const GET_WATER_PROVIDER_KPI_DESCRIPTION_BY_PROVIDER_ID = () => {
    return gql`
        query CategoryDescription($ids: [Int!]) {
            result: getWaterProviders(ids: $ids) {
                ${WATER_PROVIDER_KPI_DESCRIPTION_QUERY}
            }
        }
    `;
    // return gql`
    //     query WaterProviderKPIResult {
    //         query: taxonomyTermQuery(
    //             offset: ${offset}, limit: ${limit},
    //           filter: ${waterProviderFilter(termIds)}
    //         ) {
    //             entities ${WATER_PROVIDER_KPI_DESCRIPTION_QUERY}
    //         }
    //     }
    // `;
};

export const GET_WATER_PROVIDER_KPI_DESCRIPTION_BY_PROVIDER_ID_PARAMS = (
    termIds?: number[]
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        variables: {
            ids: number[];
        };
    };
} => {
    const allow = termIds == null || !termIds.filter(d => d != null).length ? false : true;

    return {
        query: GET_WATER_PROVIDER_KPI_DESCRIPTION_BY_PROVIDER_ID(),
        options: {
            skip: !allow,
            variables: {
                ids: termIds?.filter(d => d != null) ?? []
            }
        }
    };
};
